import React, { useState, useEffect } from "react";
import CasinoSuperskokSignIn from "../CasinoSuperskok/CasinoSuperskokSignIn.jsx";
import CasinoSuperskokMyData from "../CasinoSuperskok/CasinoSuperskokMyData.jsx";
import CasinoSuperskokInfo from "../CasinoSuperskok/CasinoSuperkokInfo.jsx";
import CasinoSuperskokTabs from "../CasinoSuperskok/CasinoSuperskokTabs.jsx";

export default function CasinoSuperSkokPageContent(props) {
    function isStarted() {
        return new Date().getTime() > new Date(props.info.aktivnoOd).getTime();
    }
    
    return (
            <>
            {props.resultsLoaded && isStarted() && <span>
                {!props.igracJeLogiran && <CasinoSuperskokSignIn {...props} />}
                {props.igracJeLogiran && <CasinoSuperskokMyData {...props} />}
            </span>
            }
            <CasinoSuperskokInfo brands={props.brands} {...props} kampanja={props.kampanja} />
            <CasinoSuperskokTabs brands={props.brands} {...props} kampanja={props.kampanja?.replace("-inTab","")} />
            </>
    )
}